import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Metodi di pagamento',
  payment_options: {
    [PaymentMethod.Card]: 'Carta di credito',
  },
};
